export const layerConstant = {
    BLOCKS : 'blocks',
    METRO : 'metro_layer',
    PARCEL_DIMENSION : 'parcel_dimension',
    dimensions : 'dimensions',
    road: 'road_poly',
    mi_stroe:'MI',
    warehouse:'warehouse',
    industry_workshop_warehouse_cat:'industry_workshop_warehouse',
    env_based_style:'env_based_style',
    parcel_dimension: 'parcel_dimension',
    miprojects: 'miprojects',
    parcel: 'property_details',
    miprojects_labels: [
        {
            "legend_type": "Points",
            "circle": true,
            "display": true,
            "label": {
                "1": "Points",
                "2": "نقاط"
            },
            "data": [
                {
                    "value": "Projects (Under Construction)",
                    "valueAR": "المشاريع (قيد الإنشاء)",
                    "layer_status": true,
                    "developed": false,
                    "circle": true,
                    "color": "#f37f3a",
                    "label": {
                        "1": "Projects (Under Construction)",
                        "2": "المشاريع (قيد الإنشاء)"
                    }
                },
                {
                    "value": "Projects (Developed)",
                    "valueAR": "المشاريع (المُطوّرة)",
                    "layer_status": true,
                    "developed": true,
                    "circle": true,
                    "color": "#f37f3a",
                    "label": {
                        "1": "Projects (Developed)",
                        "2": "المشاريع (المُطوّرة)"
                    }
                }
            ],
        }
    ],
    zoning: 'zoning',
    category: 'category',
    transaction_summary:'transaction_summary',
    unit_summary:'unit_summary',
    rentalComponentList : ['office-space-rental', 'office-space-rental-basic', 'office-space-rental-v2', 'office-space-rental-basic-v2','retail-rental','retail-rental-basic','retail-rental-v2','retail-rental-basic-v2','warehouse-rental','warehouse-rental-v2','residential-rental-occupancy-basic-v2','residential-rental-occupancy-v2', 'office_rental','residential_rental', 'retail_rental', 'warehouse_rental'],
    satellite:'satellite',
    default:'default',
    default_filter : new Set<string>(['oid', 'gid', 'rid', 'transaction_date', 'year','centroid','property_category','zoom','unit_category']),
    rentalClusters: [
        Object.freeze({   
          label:{'1': 'None', '2': 'لا يوجد'}, 
          default: false,
          isLumsum: false,
          value:'none'
        }),
        Object.freeze({   
          label:{'1': "Rent Rate", '2': "سعر الإيجار"}, 
          default: true,
          isLumsum: false,
          value:'rate'
        }),
        Object.freeze({   
          label:{'1': 'Rent Lumpsum', '2': 'اجمالي الايجار'}, 
          default: false,
          isLumsum: true,
          value:'lumpsum'
        })
      ]
}

export const categoryGrops = [
  {
    name: "poly_clinic_investment",
    match: ["poly clinic"],
    condition: (categories: string[], country: string) =>
      country.toLowerCase() === "kwt" && categories.includes("poly"),
  },
  {
    name: "residential_investment",
    match: ["multi_story_residential"],
    condition: (categories: string[], country: string) =>
      country.toLowerCase() === "kwt" && categories.includes("multi_story_residential"),
  },
  {
    name: "mixed_commercial",
    match: ["retail_f_b_and_entertainment", "multi_story_office"],
    condition: (categories: string[]) =>
      categories.includes("retail_f_b_and_entertainment") &&
      categories.includes("multi_story_office"),
  },
  {
    name: "retail_commercial",
    match: ["retail_f_b_and_entertainment"],
    condition: (categories: string[]) =>
      categories.includes("retail_f_b_and_entertainment"),
  },
  {
    name: "office_commercial",
    match: ["multi_story_office"],
    condition: (categories: string[]) =>
      categories.includes("multi_story_office"),
  },
  {
    name: "hospitality",
    match: ["hospitality", 'healthcare'],
    condition: (categories: string[]) => 
      categories.includes("hospitality") || categories.includes("healthcare"),
  },
  {
    name: "industrial",
    match: ["industry_workshop_warehouse"],
    condition: (categories: string[]) =>
      categories.includes("industry_workshop_warehouse"),
  },
  {
    name: "residential",
    match: ["villa_house", "multi_story_residential"],
    condition: (categories: string[]) =>
      categories.includes("villa_house") || categories.includes("multi_story_residential"),
  },
  
];

export const CATEGORY_GROUP_NAMES: Record<string, string> = {
  mixed_commercial: 'assets/patterns/mixed_commercial.png',
  retail_commercial: 'assets/patterns/retail.png',
  office_commercial: 'assets/patterns/office.png',
  hospitality: 'assets/patterns/hospitality.png',
  industrial: 'assets/patterns/industrial_.png',
  residential: 'assets/patterns/residential.png',
  poly_clinic_investment: 'assets/patterns/poly.png',
  residential_investment: 'assets/patterns/residential_investment.png',
  other:'assets/patterns/other.png',
};
export const CATEGORY_GROUP_NAMES_LEGEND: Record<string, string> = {
  mixed_commercial: 'assets/patterns/mixed_commercial.png',
  retail_commercial: 'assets/patterns/retail-thumb.png',
  office_commercial: 'assets/patterns/office.png',
  hospitality: 'assets/patterns/hospitality-thumb.png',
  industrial: 'assets/patterns/industrial_.png',
  residential: 'assets/patterns/residential.png',
  poly_clinic_investment: 'assets/patterns/poly.png',
  residential_investment: 'assets/patterns/residential_investment.png',
  other:'assets/patterns/other.png',
};


